import { UrlConstants } from "../url.constants";
export class ApiZoningCertificateConstants {
    static URL = UrlConstants.API_V2 + "ZoningCertificate";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetZoningCertificateProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateZoningCertificateInvoiceReport";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalZoningCertificateApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetZoningCertificateRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER = "VerifyResubmissionReferenceNumber";
}
